import { render, staticRenderFns } from "./SalesProductPhysicalListTop.vue?vue&type=template&id=8c319ce4&scoped=true&"
import script from "./SalesProductPhysicalListTop.vue?vue&type=script&lang=js&"
export * from "./SalesProductPhysicalListTop.vue?vue&type=script&lang=js&"
import style0 from "./SalesProductPhysicalListTop.vue?vue&type=style&index=0&id=8c319ce4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c319ce4",
  null
  
)

export default component.exports